// extracted by mini-css-extract-plugin
module.exports = {"button":"Edit_button__3WDLE","tourName":"Edit_tourName__1v13N","tourSave":"Edit_tourSave__1JDX_","tourCaretakers":"Edit_tourCaretakers__U2CBD"};